export default {
  "hello": "Салом",
  "usd": "USD",
  "uzs": "cум"
};